package com.picme.sdk2.generated.collection2

import com.lightningkite.kiteui.HttpMethod
import kotlinx.serialization.KSerializer
import kotlinx.serialization.Serializable
import kotlinx.serialization.descriptors.PrimitiveKind
import kotlinx.serialization.descriptors.PrimitiveSerialDescriptor
import kotlinx.serialization.descriptors.SerialDescriptor
import kotlinx.serialization.encoding.Decoder
import kotlinx.serialization.encoding.Encoder
import kotlin.jvm.JvmInline
import kotlinx.datetime.Instant
import com.picme.sdk2.*
import com.picme.sdk2.generated.*


class CollectionHandler2ApiLive(val endpoints: CollectionHandler2Endpoints, val accessToken: suspend () -> String?): CollectionHandler2Api {
/** Gets both full metadata and a URI for the "details" version of a deleted upload.
            If the upload has not been deleted, this function will throw an exception.
            Requires <see cref="F:SimpleDatabase.Rights.Read" /> and <see cref="F:SimpleDatabase.Rights.Delete" /> participation rights on the collection. **/
    override suspend fun getDeletedUpload(
        collectionId: CollectionId,
        uploadId: UploadId,
    ): GetDeletedUploadResponse2 = endpoints.getDeletedUpload(
        collectionId = collectionId,
        uploadId = uploadId,
        accessToken = accessToken,
    )
/** Lists links from the specified collection.
            Requires ownership of the collection. **/
    override suspend fun listLinksFrom(
        linkRelationshipType: LinkRelationshipType,
        collectionId: CollectionId,
    ): ListLinksToResponse2 = endpoints.listLinksFrom(
        linkRelationshipType = linkRelationshipType,
        collectionId = collectionId,
        accessToken = accessToken,
    )
/** Deletes the cover photo for a collection.
            Requires <see cref="F:SimpleDatabase.Rights.Update" /> rights on the collection. **/
    override suspend fun deleteCollectionCoverPhoto(
        collectionId: CollectionId,
        photoId: String,
    ): Unit = endpoints.deleteCollectionCoverPhoto(
        collectionId = collectionId,
        photoId = photoId,
        accessToken = accessToken,
    )
/** Lists links to the specified collection.
            Requires ownership of the collection. **/
    override suspend fun listLinksTo(
        linkRelationshipType: LinkRelationshipType,
        collectionId: CollectionId,
    ): ListLinksToResponse2 = endpoints.listLinksTo(
        linkRelationshipType = linkRelationshipType,
        collectionId = collectionId,
        accessToken = accessToken,
    )
/** Gets both full metadata and a URI for the "details" version of the upload.
            If the upload has been deleted, this function will throw an exception.
            If the user is not the user who created the upload, requires <see cref="F:SimpleDatabase.Rights.Read" /> participation rights on the collection uploads. **/
    override suspend fun getUpload(
        collectionId: CollectionId,
        uploadId: UploadId,
    ): GetUploadResponse2 = endpoints.getUpload(
        collectionId = collectionId,
        uploadId = uploadId,
        accessToken = accessToken,
    )
/** Patches an existing upload with new data (at least the parts that are editable).
            Requires <see cref="F:SimpleDatabase.Rights.Update" /> participation rights on the collection uploads. **/
    override suspend fun patchUpload(
        collectionId: CollectionId,
        uploadId: UploadId,
        body: PatchUploadBody,
    ): PatchUploadResponse2 = endpoints.patchUpload(
        collectionId = collectionId,
        uploadId = uploadId,
        body = body,
        accessToken = accessToken,
    )
/** Deletes an upload from a collection.
            Requires <see cref="F:SimpleDatabase.Rights.Delete" /> participation rights on the collection. **/
    override suspend fun deleteUpload(
        collectionId: CollectionId,
        uploadId: UploadId,
    ): DeleteUploadResponse2 = endpoints.deleteUpload(
        collectionId = collectionId,
        uploadId = uploadId,
        accessToken = accessToken,
    )
/** Copies the specified source upload from the source collection to the specified destination collection.
            If the user is not the user who created the upload, requires <see cref="F:SimpleDatabase.Rights.Read" /> participation rights on the source collection uploads.
            Requires <see cref="F:SimpleDatabase.Rights.Create" /> participation rights on the destination collection uploads.
            If an upload already with the specified identified hash already exists and <paramref name="allowDuplicates" /> is false, an <see cref="T:NetworkExceptions.AlreadyExistsException" /> will be thrown and this exception will contain identifiers for the duplicate upload in case the client wants to show it to the user. **/
    override suspend fun copyUpload(
        caption: String?,
        sourceCollectionId: CollectionId,
        sourceUploadId: UploadId,
        destinationCollectionId: CollectionId,
        anonymous: Boolean,
        allowDuplicates: Boolean,
    ): CopyUploadResponse2 = endpoints.copyUpload(
        caption = caption,
        sourceCollectionId = sourceCollectionId,
        sourceUploadId = sourceUploadId,
        destinationCollectionId = destinationCollectionId,
        anonymous = anonymous,
        allowDuplicates = allowDuplicates,
        accessToken = accessToken,
    )
/** Gets the collection modification stamp, which changes every time the collection is updated. **/
    override suspend fun getCollectionModificationStamp(
        collectionId: CollectionId,
    ): GetCollectionModificationStampResponse2 = endpoints.getCollectionModificationStamp(
        collectionId = collectionId,
        accessToken = accessToken,
    )
/** Puts a new cover photo for a collection.
            Requires <see cref="F:SimpleDatabase.Rights.Update" /> rights on the collection. **/
    override suspend fun putCollectionCoverPhoto(
        collectionId: CollectionId,
        contentType: String,
    ): PutCollectionCoverPhotoResponse = endpoints.putCollectionCoverPhoto(
        collectionId = collectionId,
        contentType = contentType,
        accessToken = accessToken,
    )

    override suspend fun listDeletedUploads(
        collectionId: CollectionId,
        continuation: String?,
        uploadsPerPage: Int32?,
    ): ListDeletedUploadsResponse2 = endpoints.listDeletedUploads(
        collectionId = collectionId,
        continuation = continuation,
        uploadsPerPage = uploadsPerPage,
        accessToken = accessToken,
    )
/** Restores one or more deleted uploads to a collection.
            Requires <see cref="F:SimpleDatabase.Rights.Delete" /> participation rights on the collection. **/
    override suspend fun restoreDeletedUploads(
        collectionId: CollectionId,
        uploadIds: List<UploadId>?,
    ): RestoreDeletedUploadsResponse2 = endpoints.restoreDeletedUploads(
        collectionId = collectionId,
        uploadIds = uploadIds,
        accessToken = accessToken,
    )
/** Lists the keywords for a given property used by uploads in the specified collection.
            Requires <see cref="F:SimpleDatabase.Rights.List" /> participation rights on the collection uploads. **/
    override suspend fun listUploadKeywords(
        collectionId: CollectionId,
        propertyPath: String,
        keyWordPrefix: String,
    ): ListUploadKeywordsResponse = endpoints.listUploadKeywords(
        collectionId = collectionId,
        propertyPath = propertyPath,
        keyWordPrefix = keyWordPrefix,
        accessToken = accessToken,
    )
/** Gets an existing or starts a new zip of the originals for the specified uploads in the collection.
            Requires <see cref="F:SimpleDatabase.Rights.List" /> and <see cref="F:SimpleDatabase.Rights.Read" /> participation rights on the collection and <see cref="F:SimpleDatabase.Rights.List" /> and <see cref="F:SimpleDatabase.Rights.Read" /> rights on the collection. **/
    override suspend fun getOrStartPartialZipOfOriginals(
        collectionId: CollectionId,
        uploadIds: List<UploadId>,
    ): GetOrStartPartialZipOfOriginalsResponse2 = endpoints.getOrStartPartialZipOfOriginals(
        collectionId = collectionId,
        uploadIds = uploadIds,
        accessToken = accessToken,
    )
/** Gets an existing or starts a new zip of the originals for all the uploads in the collection.
            Requires <see cref="F:SimpleDatabase.Rights.List" /> and <see cref="F:SimpleDatabase.Rights.Read" /> participation rights on the collection and <see cref="F:SimpleDatabase.Rights.List" /> and <see cref="F:SimpleDatabase.Rights.Read" /> rights on the collection. **/
    override suspend fun getOrStartFullZipOfOriginals(
        collectionId: CollectionId,
    ): GetOrStartFullZipOfOriginalsResponse2 = endpoints.getOrStartFullZipOfOriginals(
        collectionId = collectionId,
        accessToken = accessToken,
    )
/** Connects a new sharee user to a collection using a legacy externally-communicated collection sharing authorization code. **/
    override suspend fun sharingConnect(
        authorization: CollectionSharingAuthorizationCode,
        collectionId: String,
    ): Unit = endpoints.sharingConnect(
        authorization = authorization,
        collectionId = collectionId,
        accessToken = accessToken,
    )
/** Creates a new upload and gets a <see cref="T:System.Uri" /> to PUT the binary data.  Fails if an upload with the specified hash already exists.
            Requires <see cref="F:SimpleDatabase.Rights.Create" /> participation rights on the collection uploads.
            If an upload already with the specified identified hash already exists and <paramref name="allowDuplicates" /> is false, an <see cref="T:NetworkExceptions.AlreadyExistsException" /> will be thrown and this exception will contain identifiers for the duplicate upload in case the client wants to show it to the user. **/
    override suspend fun createUpload(
        collectionId: CollectionId,
        body: CreateUploadBody,
        allowDuplicates: Boolean,
    ): CreateUploadResponse2 = endpoints.createUpload(
        collectionId = collectionId,
        body = body,
        allowDuplicates = allowDuplicates,
        accessToken = accessToken,
    )

    override suspend fun listUploads(
        collectionId: CollectionId,
        filter: UploadCondition?,
        filterQuery: UploadQuery?,
        continuation: String?,
        uploadsPerPage: Int32?,
    ): ListUploadsResponse2 = endpoints.listUploads(
        collectionId = collectionId,
        filter = filter,
        filterQuery = filterQuery,
        continuation = continuation,
        uploadsPerPage = uploadsPerPage,
        accessToken = accessToken,
    )
/** Deletes all uploads from a collection.
            Requires <see cref="F:SimpleDatabase.Rights.Delete" /> participation rights on the collection. **/
    override suspend fun deleteAllUploads(
        collectionId: CollectionId,
    ): DeleteAllUploadsResponse2 = endpoints.deleteAllUploads(
        collectionId = collectionId,
        accessToken = accessToken,
    )
/** Revokes rights to a collection that were previously granted to a user by a Link (probably through a Invite code).
            The caller may be the owner, and may specify the user whose rights should be revoked,
            or the caller may be the user who wants their own rights to the collection revoked. **/
    override suspend fun revokeRights(
        collectionId: CollectionId,
        userId: UserId,
    ): RevokeRightsResponse2 = endpoints.revokeRights(
        collectionId = collectionId,
        userId = userId,
        accessToken = accessToken,
    )
/** Modifies existing right to a collection that were previously granted to a user by a Link (probably through a Invite code).
            The caller is usually the owner, who must specify the user whose rights should be modified,
            or the caller may be the user who wants to reduce their own rights to the collection (but not revoke them entirely). **/
    override suspend fun modifyRights(
        collectionId: CollectionId,
        userId: UserId,
        newRights: Rights,
    ): ModifyRightsResponse = endpoints.modifyRights(
        collectionId = collectionId,
        userId = userId,
        newRights = newRights,
        accessToken = accessToken,
    )
/** Connects a new guest user to a collection using a legacy externally-communicated upload request authorization code. **/
    override suspend fun requestConnect(
        collectionId: CollectionId,
    ): Unit = endpoints.requestConnect(
        collectionId = collectionId,
        accessToken = accessToken,
    )

    override suspend fun getCollectionRights(
        collectionId: CollectionId,
        targetUserId: UserId?,
    ): GetCollectionRightsResponse2 = endpoints.getCollectionRights(
        collectionId = collectionId,
        targetUserId = targetUserId,
        accessToken = accessToken,
    )
/** Gets information about the specified collection. **/
    override suspend fun getCollection(
        collectionId: CollectionId,
    ): GetCollectionResponse2 = endpoints.getCollection(
        collectionId = collectionId,
        accessToken = accessToken,
    )
/** Patches an existing collection. **/
    override suspend fun patchCollection(
        collectionId: CollectionId,
        body: PatchCollectionBody,
    ): PatchCollectionResponse2 = endpoints.patchCollection(
        collectionId = collectionId,
        body = body,
        accessToken = accessToken,
    )
/** Deletes a collection and all descendant collections. **/
    override suspend fun deleteCollection(
        collectionId: CollectionId,
    ): DeleteCollectionResponse2 = endpoints.deleteCollection(
        collectionId = collectionId,
        accessToken = accessToken,
    )
/** Activates the specified Invite code.
            Any authenticated user can activate a Invite code. **/
    override suspend fun activateInviteCode(
        inviteId: InviteCodeId,
    ): ActivateInviteCodeResponse = endpoints.activateInviteCode(
        inviteId = inviteId,
        accessToken = accessToken,
    )
/** Deprecated.  Generates a QR code from the specified parameters.  Currently not authenticated, but the TLD must be picme.com or localhost, so it shouldn't be particularly useful for third parties. **/
    override suspend fun generateQrCodePng(
        hostnamePrefix: String,
        pathAndQueryStringPattern: String,
        useLogo: Boolean,
        colorLogo: Boolean,
        pixels: Int32,
    ): CreateQrCodeImageResponse = endpoints.generateQrCodePng(
        hostnamePrefix = hostnamePrefix,
        pathAndQueryStringPattern = pathAndQueryStringPattern,
        useLogo = useLogo,
        colorLogo = colorLogo,
        pixels = pixels,
        accessToken = accessToken,
    )
/** Lists all users who have activated the specified Invite code.
            Note that this includes users who activated the code and then had their rights revoked.
            Requires ownership of the Invite code. **/
    override suspend fun listActivatedUsers(
        inviteId: InviteCodeId,
    ): ListActivatedUsersResponse = endpoints.listActivatedUsers(
        inviteId = inviteId,
        accessToken = accessToken,
    )
/** Lists users that have access to the specified collection (both owners and participants).
            Requires ownership of the collection. **/
    override suspend fun listUsers(
        collectionId: CollectionId,
    ): ListUsersResponse2 = endpoints.listUsers(
        collectionId = collectionId,
        accessToken = accessToken,
    )
/** Generates a QR code with a logo from the specified parameters.  Currently not authenticated, but the TLD must be picme.com or localhost, so it shouldn't be particularly useful for third parties. **/
    override suspend fun generateQrCodeSvg(
        hostnamePrefix: String,
        pathAndQueryStringPattern: String,
        useLogo: Boolean,
        colorLogo: Boolean,
    ): CreateQrCodeImageResponse = endpoints.generateQrCodeSvg(
        hostnamePrefix = hostnamePrefix,
        pathAndQueryStringPattern = pathAndQueryStringPattern,
        useLogo = useLogo,
        colorLogo = colorLogo,
        accessToken = accessToken,
    )
/** Gets the specified Invite code object.
            Any authenticated user can call this API, whether they're related to the Invite code or its owner or not. **/
    override suspend fun getInviteCode(
        inviteId: InviteCodeId,
    ): GetInviteCodeResponse = endpoints.getInviteCode(
        inviteId = inviteId,
        accessToken = accessToken,
    )
/** Updates a Invite code object from the specified parameters.
            Only the Invite code's creator can patch it. **/
    override suspend fun patchInviteCode(
        inviteId: InviteCodeId,
        body: PatchInviteCodeBody,
    ): CreateInviteCodeResponse = endpoints.patchInviteCode(
        inviteId = inviteId,
        body = body,
        accessToken = accessToken,
    )
/** Deletes the specified Invite code object.
            Only the Invite code's creator can delete it. **/
    override suspend fun deleteInviteCode(
        inviteId: InviteCodeId,
    ): Unit = endpoints.deleteInviteCode(
        inviteId = inviteId,
        accessToken = accessToken,
    )
/** Creates a Invite code object for requesting uploads to a collection.
            The Invite code will be owned by the calling user and will be hierarchically linked to the specified collection.
            The link type for the activated link is <see cref="P:SimpleDatabase.LinkRelationshipType.ParticipationRights" /> with a link relationship of type <see cref="T:SimpleDatabase.Rights" />. **/
    override suspend fun createRequestInviteCode(
        collectionGlobalId: RecordGlobalId,
        name: String,
        clientInformation: String,
    ): CreateInviteCodeResponse = endpoints.createRequestInviteCode(
        collectionGlobalId = collectionGlobalId,
        name = name,
        clientInformation = clientInformation,
        accessToken = accessToken,
    )
/** Creates a Invite code object for requesting uploads to a collection.
            The Invite code will be owned by the calling user and will be hierarchically linked to the specified collection.
            The link type for the activated link is <see cref="P:SimpleDatabase.LinkRelationshipType.ParticipationRights" /> with a link relationship of type <see cref="T:SimpleDatabase.Rights" />. **/
    override suspend fun createSharingInviteCode(
        collectionGlobalId: RecordGlobalId,
        name: String,
        clientInformation: String,
        rightsToOtherUsersUploads: Rights,
    ): CreateInviteCodeResponse = endpoints.createSharingInviteCode(
        collectionGlobalId = collectionGlobalId,
        name = name,
        clientInformation = clientInformation,
        rightsToOtherUsersUploads = rightsToOtherUsersUploads,
        accessToken = accessToken,
    )
/** Creates a new collection. **/
    override suspend fun createCollection(
        body: CreateCollectionBody,
    ): CreateCollectionResponse2 = endpoints.createCollection(
        body = body,
        accessToken = accessToken,
    )

    override suspend fun listCollections(
        filterQuery: CollectionQuery?,
        itemsPerPage: Int32,
        continuation: String?,
        forUserId: UserId?,
    ): ListCollectionsResponse2 = endpoints.listCollections(
        filterQuery = filterQuery,
        itemsPerPage = itemsPerPage,
        continuation = continuation,
        forUserId = forUserId,
        accessToken = accessToken,
    )
/** Records an ad impression (an ad that was seen for a certain amount of time in a certain context by an end user). **/
    override suspend fun recordImpression(
        adId: String,
        collectionId: String?,
        contextId: String?,
    ): Unit = endpoints.recordImpression(
        adId = adId,
        collectionId = collectionId,
        contextId = contextId,
        accessToken = accessToken,
    )

    override suspend fun createInviteCode(
        body: CreateInviteCodeBody,
        linkParentRecord: RecordGlobalId?,
    ): CreateInviteCodeResponse = endpoints.createInviteCode(
        body = body,
        linkParentRecord = linkParentRecord,
        accessToken = accessToken,
    )

    override suspend fun listInviteCodes(
        linkRelationshipType: LinkRelationshipType?,
        linkPrimaryGlobalId: RecordGlobalId?,
    ): ListInviteCodesResponse = endpoints.listInviteCodes(
        linkRelationshipType = linkRelationshipType,
        linkPrimaryGlobalId = linkPrimaryGlobalId,
        accessToken = accessToken,
    )
/** Lists possible ads to use for future ad impressions. **/
    override suspend fun listAds(
        collectionId: String?,
        unitTest: Boolean,
    ): ListAdsResponse = endpoints.listAds(
        collectionId = collectionId,
        unitTest = unitTest,
        accessToken = accessToken,
    )

    override suspend fun adServe(
        collectionId: String?,
        adSize: AdSize?,
        contextId: String?,
        unitTest: Boolean,
    ): RedirectResponse = endpoints.adServe(
        collectionId = collectionId,
        adSize = adSize,
        contextId = contextId,
        unitTest = unitTest,
        accessToken = accessToken,
    )
}
